export default "__VITE_ASSET__BOO$99ee__"